var map = {
	"./screenshot.png": 74774,
	"./somenergia-icon-black.png": 75820,
	"./somenergia-icon-cream.png": 93959,
	"./somenergia-icon-fluor.png": 79977,
	"./somenergia-icon-sea.png": 30344,
	"./somenergia-icon-white.png": 87414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;